import React, { useCallback, useContext, useEffect, useMemo, useState, useRef } from "react";
import { usePopper } from "react-popper";
import { Modals } from "@jd/focus-desktop-comps";
import { Tooltip, message, Modal, Tag, Menu, Dropdown } from "antd";
import { Avatar } from "@/baseComponents/Avatar";
import { changeEgovUrl, changeGovUrl, crossAppSwitch } from "@/utils/tools";
import IconFont, {
  IconArrowRight,
  IconArrowRightLayout,
  IconEdit,
  IconExit,
  IconSet,
  IconFailure,
  IconGroup,
  IconRdit,
  IconWebAddres,
  IconHoutai,
  IconWangluo,
  IconErWeiMa,
  IconAddWorkStatus
} from "@/components/icon";
import { UserCenterConfig } from "@/types/UserCenter";
import { UserCardData, UserCardType, UserCardAction, UserCardItem } from "@/types/UserCard";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useTranslation } from "react-i18next";
import Teams from "@/components/TeamManagement";
import AboutModal from "@/components/AboutModal";
import { FocusSDK, getClientType, getUserAppId, getWebEnvObj, isFocusEnv } from "@/utils";
import { connect } from "dvajs";
import { ICommonConfig, UserModel, UserState } from "@/models/user";
import { submitFeedback } from "@/api/feedback";
import Bus from "@/utils/bus";
import { getTranslationName } from "@/utils/i18n";
import "./UserCenter.less";
import { getTeamAdmin } from "@/api/user";
import PersonalQRCode from "@/components/PersonalQRCode";
import RestoreDefaultAvata from "@/components/RestoreDefaultAvata";
import UploadImageControler from "./UploadImage/UploadIamgeControler";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import { debounce, isUndefined } from "lodash";
import ChatState from "@/types/chat/State";
import Loading from "../components/Loading";
import { getEbookDeptDesc } from "@/api/ebook";
import { queryEmplMedalWall } from "@/api/reward";
import { useHistory } from "react-router-dom";
import { createUploadTask } from "@/server/FileService";
// eslint-disable-next-line no-duplicate-imports
import { changeAvatarReq } from "@/api/user";
import { Employee } from "@/types/chat";
import ImService from "@/server/ImService";
import getVersionBySdk from "@/utils/getVersion";
import { UAParser } from "ua-parser-js";
import colors from "@/components/styles/colors";
import { GlobalOutlined } from "@/utils/antdIcon";
import { setClientCurrentEmployee, tagsNode } from "@/components/AddressBook/common";
import { getJRTCToken } from "@/api/meeting";

import AccountDelay from "@/components/AccountDelay";
import dayjs from "dayjs";
import { EbookState, MangeExternalModalInfo } from "@/models/ebook";
import AdministratorModal from "@/components/Modals/AdministratorModal";
import promiseConfig, { ConfigEnum } from "@/config/config";
import { analysisLog } from "@/utils/logAnalytics";
import { getUnitName } from "@/baseComponents/Meeting/utils";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import { UpgradeTipTag } from "@/components/Tags";
import PersonalInfoModal from "@/components/Modals/PersonalInfoModal";
import ArrSvg from "@/assets/newsvg/arrow.svg";
const divider = (
  <div
    style={{
      height: 1,
      backgroundColor: "#E6E6E6",
      marginBottom: "8px"
    }}
  />
);

const Item = ({
  onClick,
  icon,
  text,
  withArrow = false,
  clstag = "",
  className = "",
  rightChildrenFn
}: {
  onClick: () => void;
  icon: any;
  text: any;
  withArrow?: boolean;
  clstag?: string;
  className?: string;
  rightChildrenFn?: any;
}) => {
  const [hover, setHover] = useState(false);
  let theclstag = clstag ? { clstag: clstag } : {};
  return (
    <div
      className={`user-item-wrap ${className}`}
      role="button"
      tabIndex={0}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onKeyDown={() => {}}
      onClick={onClick}
      {...theclstag}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center"
        }}
      >
        {icon}
        <span className="text">{text}</span>
      </div>
      <div className="right">
        {rightChildrenFn?.()}
        {withArrow && <span className="arrow">{IconArrowRightLayout}</span>}
      </div>
    </div>
  );
};

export enum UserCenterItemType {
  Setup = "setup",
  About = "about",
  Logout = "logout",
  Feedback = "feedback",
  JoinMe = "joinme",
  Manager = "manager",
  QRCode = "qrcode",
  HelpCenter = "helpCenter",
  AccountDelay = "accountDelay"
}

// config 是用于配置功能开启关闭的配置项
// eslint-disable-next-line complexity
function UserCenter(props: {
  notify?: any;
  config?: UserCenterConfig;
  getWebUserData: any;
  clearJoyspaceData: any;
  clearChatData: any;
  clearCalendarData: any;
  clearEbookData: any;
  clearUserData: any;
  clearThirdData: any;
  currentEmployee: Employee;
  setIdentityInfoModal: Function;
  updateCurrentEmployee: Function;
  setOpenAdministratorListModal: Function;
  setManageExternalModal: Function;
  manageExternalModal: MangeExternalModalInfo;
  connectState: ConnectState;
  upgradeState: Record<string, any>;
  commonConfig: ICommonConfig;
  setWorkbenchDetail: Function;
  setUserMedalWall: Function;
  userMedalWall: any;
}) {
  const { authInfo: authData, service, appRuntimeEnv, focusSDK } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const { t } = useTranslation("common");
  const { t: joinMeT } = useTranslation("joinMe");
  const {
    notify,
    config,
    getWebUserData,
    clearChatData,
    clearJoyspaceData,
    clearCalendarData,
    clearUserData,
    clearThirdData,
    clearEbookData,
    setIdentityInfoModal,
    updateCurrentEmployee,
    currentEmployee,
    connectState,
    upgradeState,
    commonConfig,
    setWorkbenchDetail,
    setUserMedalWall,
    userMedalWall
  } = props;
  const history = useHistory();
  let { teamUserInfo } = authData || {};

  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [visible, setVisible] = useState(false);
  const [userInfo, setUserInfo] = useState<UserCardData | null>(null);
  const [loading, setLoading] = useState(true);
  // const [superAdmin, setSuperAdmin] = useState(false);
  const offsetVal: number = isFocusEnv() ? -4 : -40;
  const { styles: popperStyles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "right-start",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [offsetVal, 18]
        }
      }
    ]
  });
  const [workStatus, setWorkStatus] = useState("");
  const [isAboutModalVisible, setAboutModalVisible] = useState(false);
  const [visibleQRCode, setVisibleQRCode] = useState(false);
  const [visibleDefaultAvatar, setVisibleDefaultAvatar] = useState(false);
  const [visibleAdministrator, setVisibleAdministrator] = useState({ visible: false, type: "" });
  const [visibleAccountDelay, setVisibleAccountDelay] = useState(false);
  const [visiblePersonal, setVisiblePersonal] = useState(false);
  const TOAST_ERROR_KEY = "TOAST_ERROR_KEY";
  const loadError = useRef(false);
  // eslint-disable-next-line no-debugger

  const getOSSBaseUrl = () => changeEgovUrl(getWebEnvObj().REACT_APP_OSS_BASE_URL);

  const changeWorkStatus = (data: any) => {
    setWorkStatus(data.workStatus && data.workStatus !== "无" ? data.workStatus : "");
  };
  const onHideUserCenter = (data: any) => {
    setVisible(false);
  };
  useEffect(() => {
    Bus.on("workStatus:update", changeWorkStatus);
    Bus.on("onHideUserCenter", onHideUserCenter);
    return () => {
      Bus.off("workStatus:update", changeWorkStatus);
      Bus.off("onHideUserCenter", onHideUserCenter);
    };
  }, []);

  // const onOpenUserCard = useCallback((data: { appId: string; userId: string; teamId: string }) => {
  //   const { userId, appId, teamId } = data;
  //   Bus.emit("app:toggle-user-card-modal:show", {
  //     visible: true,
  //     type: UserCardType.User,
  //     userId,
  //     teamId,
  //     appId,
  //     applyInfos: [],
  //     actions: [UserCardAction.Chat]
  //   });
  // }, []);

  const doShowQRCode = useCallback(() => [setVisibleQRCode(true)], []);
  const doSwitchQRCode = useCallback(() => [setVisibleQRCode(!visibleQRCode)], [visibleQRCode]);
  const doSwitchDefaultAvatar = useCallback(
    () => [setVisibleDefaultAvatar(!visibleDefaultAvatar)],
    [visibleDefaultAvatar]
  );

  const doShowAccountDelay = useCallback(() => {
    setVisibleAccountDelay(true);
  }, []);
  const doSwitchAccountDelay = useCallback(() => {
    analysisLog("xtbg_add_home_1637657110163", "71");
    setVisibleAccountDelay(!visibleAccountDelay);
  }, [visibleAccountDelay]);

  const doShowAdministrator = useCallback((type) => {
    setVisibleAdministrator({ visible: true, type });
  }, []);

  const doSwitchAdministrator = useCallback(() => {
    setVisibleAdministrator({
      ...visibleAdministrator,
      visible: !visibleAdministrator.visible
    });
  }, [visibleAdministrator]);

  const doPersonalInfo = useCallback(() => {
    setVisiblePersonal(!visiblePersonal);
  }, [visiblePersonal]);

  const showJoinOrCreateTeam = useMemo(() => {
    const canCreate = appRuntimeEnv.getUIConfig("canCreateTeam");
    const canJoin = appRuntimeEnv.getUIConfig("canJoinTeam");
    if (!isUndefined(canCreate) && !canCreate && !isUndefined(canJoin) && !canJoin) {
      return false;
    }
    return true;
  }, [appRuntimeEnv]);

  const doShowHelpCenter = useCallback(() => {
    let currentOrigin = FocusSDK.getMeMainEntry();
    let helpUrl = "";
    if (appRuntimeEnv.envConfig?.helpUrl) {
      helpUrl = appRuntimeEnv?.envConfig?.helpUrl;
    } else {
      helpUrl = `${currentOrigin}/guide/#/pc`;
      if (process.env.REACT_APP_NODE_ENV !== "production" && appRuntimeEnv.env !== "prod") {
        helpUrl = `${currentOrigin}/jingzhiban#/pc`;
      }
    }
    if (!isFocusEnv()) {
      helpUrl = `${helpUrl}?web=true`;
      window.open(helpUrl);
    } else {
      window.open(helpUrl);
    }
  }, [appRuntimeEnv.env, appRuntimeEnv.envConfig?.helpUrl]);

  const sendJmtLog = () => {
    return new Promise((resolve, reject) => {
      getJRTCToken({
        currentEmployee
      })
        .then(([jrcToken, err]) => {
          if (err) {
            console.log("getJRTCToken err", err);
            resolve(false);
          }
          if (isFocusEnv()) {
            FocusSDK.sendJdmtLog({
              rtcServerUrl: `https://${jrcToken.rtcDomain}`,
              meetApiUrl: new URL(`https://${jrcToken.domain}`),
              appVersion: getVersionBySdk(FocusSDK)
            });
            resolve(true);
          }
        })
        .catch((e) => {
          console.log("getJRTCToken err", e);
          resolve(false);
        });
    });
  };

  const onItemClick = useCallback(
    (type: UserCenterItemType) => {
      const userData = { ...authData, team: authData.teamUserInfo };
      switch (type) {
        case UserCenterItemType.JoinMe: {
          Teams.TeamManagement({
            userData,
            getWebUserData,
            appRuntimeEnv,
            focusSDK
          });
          break;
        }
        case UserCenterItemType.Feedback: {
          const logFiles = ["main.log", "main.old.log", "uncaughtException-latest.log"]
            .map((item) => {
              const file = focusSDK.getLogFile(item);
              if (!file) {
                return null;
              }
              return {
                ...file,
                name: item
              };
            })
            .filter((item) => !!item);
          const { destroy } = Modals.Feedback({
            t,
            userData,
            headNetCheckBtn: false,
            headNetCheckCallback: () => {
              if (!isFocusEnv()) {
                return;
              }
              focusSDK.emit("showNetTable");
            },
            onSubmit: (params: any) => {
              const { name } = FocusSDK.getApplicationInfo();
              const appVersion = isFocusEnv()
                ? getVersionBySdk(FocusSDK)
                : appRuntimeEnv.registryConfig.pkgVersion.split("-")[0];
              const appName = `${name} ${isFocusEnv() ? "desktop" : "web"}`;
              let uaParser = new UAParser();
              let os = uaParser.getOS();
              let system_version = "1.0.0";
              if (os.name && os.version) {
                system_version = `${os.name}-${os.version}`;
              }
              console.log(params, "params");
              if (params.type === "2") {
                params.logs = [];
                params.pictures = [];
              } else {
                params.expression = "";
              }
              const app = getUserAppId();
              sendJmtLog().then();
              return submitFeedback({
                params: { ...params, appName, app, appVersion, system_version }
              });
            },
            onCancel: () => {
              destroy();
            },
            uploadImageControler: new UploadImageControler(appRuntimeEnv),
            logFiles,
            isHiddenSelectLog: !isFocusEnv(),
            ossBaseUrl: getOSSBaseUrl()
          });
          break;
        }
        case UserCenterItemType.About: {
          setAboutModalVisible(true);
          break;
        }
        case UserCenterItemType.Manager: {
          // 管理员入口 废弃
          let a: any = document.createElement("a");
          let url = "https://me-pre.jdcloud.com";
          a.target = "_blank";
          if (appRuntimeEnv.runtimeConfig.key === "mebjJZB") {
            url = "https://jzb.jdcloud.com/";
          } else if (appRuntimeEnv.env === "beta") {
            url = "https://me-pre.jdcloud.com/admin";
          } else {
            url = "https://me.jdcloud.com/admin";
          }
          a.href = url;
          a.click();
          break;
        }
        case UserCenterItemType.Logout:
          FocusSDK.printLog("UserCenterItemType.Logout", "logout");
          console.log("loginouttest");
          focusSDK.logout();
          break;
        case UserCenterItemType.QRCode:
          doShowQRCode();
          break;
        case UserCenterItemType.AccountDelay:
          doShowAccountDelay();
          break;
        case UserCenterItemType.HelpCenter:
          doShowHelpCenter();
          break;
        default:
      }
    },
    [authData, t] //eslint-disable-line
  );
  const ToPerfect = useCallback(() => {
    setIdentityInfoModal(true);
    setVisible(false);
  }, [setIdentityInfoModal]);

  const onGetUserInfo = useCallback(
    async (params: { userId: string; teamId: string; appId: string }): Promise<UserCardData> => {
      const imService = ImService.getInstance();
      console.log(imService, "imServiceonGetUserInfo");
      return imService.getUserProfile({ ...params, isMulti: true });
    },
    [] //eslint-disable-line
  );

  const onLogout = useCallback(() => {
    clearJoyspaceData();
    clearChatData();
    clearCalendarData();
    clearEbookData();
    clearUserData();
    clearThirdData();
  }, [
    clearJoyspaceData,
    clearChatData,
    clearCalendarData,
    clearEbookData,
    clearUserData,
    clearThirdData
  ]);

  const userStatusClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    Bus.emit("workStatus:show");
  }, []);

  const getUserData = (data: any) => {
    let res = { ...data };
    let fields: { [propName: string]: any } = {};
    (res.fields || []).forEach((fieldItem: any) => {
      fields[fieldItem.key] = fieldItem.val;
    });
    return {
      ...fields,
      ...res?.partTimeTitleDeptInfo?.[0],
      ...res
    };
  };

  const getNewAuthData = (data: any, avatarUrl: string) => {
    const teamUserInfoList = (data.teamUserInfoList || []).map((listItem: any) => {
      if (authData.selectedTeamId === listItem.teamId) {
        listItem.headImg = avatarUrl;
      }
      return listItem;
    });
    return {
      ...data,
      headImg: avatarUrl,
      teamUserInfo: { ...data.teamUserInfo, headImg: avatarUrl },
      teamUserInfoList
    };
  };

  const getEmplMedalWall = useCallback(() => {
    const { userId, ddAppId } = authData;
    const { selectedTeamId } = appRuntimeEnv;
    queryEmplMedalWall({
      userId,
      teamId: selectedTeamId,
      appId: ddAppId
    }).then((res) => {
      const [data, error] = res;
      if (data) {
        setUserMedalWall(data);
      }
    });
  }, [appRuntimeEnv, authData, setUserMedalWall]);

  React.useEffect(() => {
    if (config && (!config.layout_user_center || !config.layout_user_center_card)) {
      return () => {};
    }
    if (onGetUserInfo && visible) {
      const { userId, ddAppId, headImg } = authData;
      const { selectedTeamId } = appRuntimeEnv;
      onGetUserInfo({
        userId,
        teamId: selectedTeamId,
        appId: ddAppId
      })
        .then((res: any) => {
          if (!res) return;
          try {
            setWorkStatus(res.workStatus ? JSON.parse(res.workStatus).workStatus : "");
          } catch (error) {}
          setUserInfo(res);
          const info = getUserData(res);
          updateCurrentEmployee(info);
          if (headImg !== info.avatar && isFocusEnv()) {
            const newAuth = getNewAuthData(authData, info.avatar);
            // 更新
            FocusSDK.sendMainMessage("setAuthInfo", newAuth);
          }
        })
        .catch(async (err: any) => {
          message.error(err.message);
          await getClientUser({
            pin: userId,
            app: ddAppId,
            teamId: selectedTeamId
          });
        })
        .finally(() => {
          setLoading(false);
          // 获取积分
          // getEmplMedalWall();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, authData, onGetUserInfo, config, appRuntimeEnv, updateCurrentEmployee]);

  useEffect(() => {
    if (connectState === ConnectState.READY && loadError.current === true) {
      updateCurrentEmployee({
        ...currentEmployee,
        avatar: currentEmployee.avatar
          ? `${currentEmployee.avatar}&ver=${new Date().getTime()}`
          : ""
      });
      loadError.current = false;
    }
  }, [connectState, currentEmployee, updateCurrentEmployee]);

  // 异常情况获取不到网络接口时 获取本地缓存信息
  const getClientUser = useCallback(async (params) => {
    const data = await setClientCurrentEmployee(params);
    if (currentEmployee.avatar) {
      data.avatar = currentEmployee.avatar;
      if (data.fields.find((e: any) => e.key === "avatar")) {
        data.fields.find((e: any) => e.key === "avatar").val = currentEmployee.avatar;
      }
    }
    updateCurrentEmployee(getUserData(data));
    setUserInfo(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmployee]);

  useEffect(() => {
    focusSDK.on("logout", onLogout);
    return () => {
      focusSDK.off("logout", onLogout);
    };
  }, [onLogout]); //eslint-disable-line

  const headImg = useMemo(() => {
    return currentEmployee?.avatar || "";
  }, [currentEmployee]);

  const username = useMemo(() => {
    return currentEmployee?.name || "";
  }, [currentEmployee]);

  // useEffect(() => {
  //   if (!userInfo || !userInfo.fields) return;
  //   let newAvatar = userInfo?.fields.find((item: any) => item.key === "avatar")?.val;
  //   if (headImg !== newAvatar) {
  //     setHeadImg(newAvatar);
  //   }
  //   let newUserName = userInfo?.fields.find((item: any) => item.key === "name")?.val;
  //   if (username !== newUserName) {
  //     setUsername(newUserName);
  //   }
  //   // getTeamAdmin().then((res: any) => {
  //   //     console.log(res.result.includes(1) || res.result.includes(3), 999);
  //   //     if (res.result.includes(1) || res.result.includes(3)) {
  //   //         setSuperAdmin(true);
  //   //     }
  //   // });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userInfo]);

  const [sanding, setSanding] = useState({ content: "", title: "", visible: false });

  const userInfoCallback = useCallback(
    (info) => {
      const mainInfo = userInfo?.partTimeTitleDeptInfo
        ? userInfo?.partTimeTitleDeptInfo[0]
        : userInfo?.mainTitleDeptInfo;
      if (!["部门", "单位"].includes(info.key) || !userInfo || !mainInfo) return;

      if (mainInfo.unitIsClick && info.key === "单位") {
        analysisLog("xtbg_pc_personal_infor_1687846378111", "4");
        getEbookDeptDesc(mainInfo.unitDeptId, userInfo.teamId).then((res: any) => {
          setSanding({ content: res?.deptDesc || "", title: "单位", visible: true });
        });
      } else if (mainInfo.deptIsClick && info.key === "部门") {
        analysisLog("xtbg_pc_personal_infor_1687846378111", "5");
        getEbookDeptDesc(mainInfo.deptId, userInfo.teamId).then((res: any) => {
          setSanding({ content: res?.deptDesc || "", title: "部门", visible: true });
        });
      } else {
        message.destroy();
        message.warning({
          content: `无${info.key}三定信息`,
          icon: <IconFont type="iconlog_warning" style={{ color: "#F4B754" }} />
        });
      }
    },
    [userInfo]
  );

  const changeAvatar = useCallback(
    (file: any) => {
      const reader = new FileReader();
      const blob: any = file.getAsFile ? file.getAsFile() : file;
      reader.onload = (evt) => {
        if (!evt.target) return;
        const dataUrl: any = evt.target.result;
        const img = new Image();
        img.src = dataUrl;
        img.onload = () => {
          const task = createUploadTask("id", file, {
            needAuthn: 0, // 是否需要下载健全，可选参数默认需要 上传头像和移动端保持一致，不健全，传0
            fileName: file.name, // 文件名称
            fileType: file.type || "application/octet-stream", // 文件类型
            fileSize: file.size, // 文件大小
            appKey: appRuntimeEnv.fileService.avatarAppKey
          });
          task?.on("state", async (state1: any) => {
            if (state1.state === "completed") {
              if (!state1.downloadUrl) return;
              let avatar = state1.downloadUrl;
              // 更换头像 更新本地个人信息数据
              updateCurrentEmployee({ ...currentEmployee, avatar });
              const avatarUrl = changeGovUrl(avatar);
              changeAvatarReq({ avatar: avatarUrl })
                .then((res) => {
                  // const imService = ImService.getInstance();
                  // imService.getEmployeeDetail({
                  //   appId: currentEmployee.app || "",
                  //   userId: currentEmployee.userId,
                  //   teamId: currentEmployee.teamId
                  // });
                })
                .catch((e) => {
                  console.log("getEmployeeDetail--err", e);
                });
              if (isFocusEnv()) {
                const newAuth = getNewAuthData(authData, avatar);
                // 更新
                FocusSDK.sendMainMessage("setAuthInfo", newAuth);
              }
            } else if (state1.state === "failed") {
              message.error(state1?.reason?.message || "图片上传失败，请重试！");
              // message.error("图片上传失败，请重试！");
            }
          });
          task?.start();
          if (task!.file.size > 4 * 1024 * 1024) {
            task?.cancel();
            message.error("请上传4MB以内的JPG、JPEG、PNG、BMP、GIF格式的图片");
          }
        };
      };
      if (blob instanceof Blob) {
        reader.readAsDataURL(blob);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authData, currentEmployee, updateCurrentEmployee]
  );

  const selectImg = useCallback(() => {
    const input = document.createElement("INPUT");
    document.body.appendChild(input);
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/jpeg,image/png,image/bmp,image/gif");
    document.body.appendChild(input);
    input.onchange = (ev: any) => {
      if (ev.target.files) {
        changeAvatar(ev.target.files[0]);
      }
    };
    input.click();
    document.body.removeChild(input);
  }, [changeAvatar]);

  const userInfolistV2 = useMemo(() => {
    const userInfoList: any[] = [];
    if (userInfo) {
      const { fields = [] } = userInfo;
      const deptInfo = userInfo?.partTimeTitleDeptInfo?.[0];
      if (deptInfo?.unitName) userInfoList.push({ key: "单位", value: deptInfo?.unitName });
      // 不同显示
      if (
        userInfo?.userType !== "1" &&
        deptInfo?.unitName &&
        deptInfo?.deptName &&
        deptInfo?.unitName !== deptInfo?.deptName
      ) {
        userInfoList.push({ key: "部门", value: deptInfo?.deptName });
      }
      if (deptInfo?.titleName) userInfoList.push({ key: "职务", value: deptInfo?.titleName });
      // if (deptInfo?.titleDutyName) userInfoList.push({ key: "职责", value: deptInfo?.titleDutyName });;

      // const mobile = fields.find((item) => item.key === "mobile");

      // const email = fields.find((item) => item.key === "email");
      // email?.val && userInfoList.push({ key: "邮箱", value: email.val });

      // const cardNumber = fields.find((item) => item.key === "cardNumber");
    }
    return userInfoList;
  }, [userInfo]);

  const itemListV2 = useMemo(() => {
    const lists = [];
    // 二维码
    lists.push(
      <Item
        text={t("userCenter.qrcode")}
        icon={IconErWeiMa}
        onClick={() => {
          if (onItemClick) {
            onItemClick(UserCenterItemType.QRCode);
          }
        }}
      />
    );
    // 账号有效期
    if (userInfo?.validDate) {
      lists.push(
        <Item
          text={t("userCenter.accountDelay")}
          icon={<IconFont type="iconapp_ic_schedule11" />}
          onClick={() => {
            if (onItemClick) {
              onItemClick(UserCenterItemType.AccountDelay);
            }
          }}
        />
      );
    }
    // lists.push(divider);
    // 管理后台
    // if (userInfo?.adminUrl) {
    //   console.log("userInfo?.adminUrl", userInfo?.adminUrl);
    //   lists.push(
    //     <Item
    //       withArrow={false}
    //       text={t("userCenter.manager")}
    //       icon={IconHoutai}
    //       onClick={() => {
    //         window.open(userInfo?.adminUrl);
    //       }}
    //     />
    //   );
    // }
    // 常用网址
    !!crossAppSwitch("help") &&
      lists.push(
        <Item
          text="常用网站"
          icon={IconWebAddres}
          onClick={() => {
            const url = changeEgovUrl(
              "https://jzb.beijing.gov.cn/guide/#/webAddress?timestamp=" + Date.now()
            );
            const pre_url =
              "https://jzb-pre.jdcloud.com/jingzhiban#/webAddress?timestamp=" + Date.now();
            window.open(appRuntimeEnv.key === "prod" ? url : pre_url, "_blank");
          }}
        />
      );
    // 网络检测
    if (isFocusEnv() && crossAppSwitch("netWork")) {
      lists.push(
        <Item
          text="网络检测"
          icon={IconWangluo}
          onClick={() => {
            FocusSDK.emit("showNetTable");
          }}
        />
      );
    }
    // 帮助中心
    !!crossAppSwitch("help") &&
      lists.push(
        <Item
          text={t("userCenter.helpcenter")}
          icon={<IconFont type="iconpc_butten_help_kjia" />}
          onClick={() => {
            if (onItemClick) {
              onItemClick(UserCenterItemType.HelpCenter);
            }
            setVisible(false);
          }}
        />
      );

    // 系统设置
    lists.push(
      <Item
        text="系统设置"
        rightChildrenFn={null}
        icon={IconSet}
        onClick={() => {
          // FocusSDK.checkUrlOnline({
          //     type: 'zoomNet',
          //     isPrivateNet: FocusSDK.isPrivateNet(),
          // });
          setVisible(false);
          history.push("/systemSetting");
        }}
        clstag="pageclick|keycount|focus_home_01_1615797361152|8"
      />
    );
    // 退出登录
    lists.push(divider);
    // 问题与意见
    lists.push(
      <Item
        text={t("userCenter.feedback")}
        icon={IconRdit}
        onClick={() => {
          if (onItemClick) {
            onItemClick(UserCenterItemType.Feedback);
          }
          setVisible(false);
        }}
        clstag="pageclick|keycount|focus_home_01_1615797361152|7"
      />
    );
    lists.push(
      <Item
        key="userCenter.logout"
        withArrow={false}
        text={t("userCenter.logout")}
        className="logout-btn"
        icon={IconExit}
        onClick={() => {
          if (onItemClick) {
            setWorkbenchDetail({
              currentSelectedWorkbench: {}
            });
            onItemClick(UserCenterItemType.Logout);
          }
          // setVisible(false);
        }}
      />
    );
    return lists;
  }, [
    appRuntimeEnv.key,
    history,
    onItemClick,
    setWorkbenchDetail,
    t,
    upgradeState.show,
    userInfo?.validDate
  ]);

  const userCenterBodyV2 = useMemo(() => {
    return (
      <>
        <div
          className="header-wrap"
          onClick={() => {
            doPersonalInfo();
            setVisible(false);
          }}
        >
          <div className="avatar-wrap">
            <Avatar
              styleObj={{
                width: 48,
                height: 48,
                borderRadius: 6,
                overflow: "hidden",
                fontSize: 20,
                cursor: "pointer"
              }}
              tag={currentEmployee?.accountType === 1 ? "公共账号" : ""}
              src={headImg ? changeEgovUrl(getHeadImgThumbUrl(headImg, 150, 150)) : ""}
              name={username}
              onLoadError={() => {
                loadError.current = true;
              }}
            />
          </div>
          <div className="intro-wrap">
            <div className="name-wrap">
              <span className="name ellipsis">{username}</span>
              {userInfo?.labelInfoList && tagsNode(userInfo?.labelInfoList)}
            </div>
            <span className="unit ellipsis">
              {(userInfolistV2 || []).map((item: any, idx: number) => {
                return (
                  <span key={item.key}>{`${item.value}${
                    idx < userInfolistV2.length - 1 ? "-" : ""
                  }`}</span>
                );
              })}
            </span>
          </div>
          <div className="more-wrap">
            <span className="more-icon"><ArrSvg /></span>
          </div>
        </div>
        {userMedalWall?.length ? (
          <div className="honor-wrap">
            {userMedalWall.map((item: any) => {
              return <img src={changeEgovUrl(item.fileUrl)} key={item.bizId} className="item" />;
            })}
          </div>
        ) : null}
        <div className="status-wrap" onClick={userStatusClick}>
          <div className="content ellipsis">{workStatus || IconAddWorkStatus}</div>
          <span className="status-edit">
            <IconFont type="iconapp_btn_edit" style={{ marginRight: "4px" }} />
          </span>
        </div>
        {itemListV2}
        {/* 二维码 */}
        {visibleQRCode && (
          <PersonalQRCode
            userInfo={currentEmployee}
            visible={visibleQRCode}
            onCancel={doSwitchQRCode}
          />
        )}
        {/* 个人信息 */}
        {visiblePersonal && (
          <PersonalInfoModal
            visible={visiblePersonal}
            onCancel={doPersonalInfo}
            userInfo={userInfo}
            headImg={headImg}
            username={username}
            showAdminModal={() => {
              doShowAdministrator("Administrator");
            }}
            showUnitAdminModal={() => {
              doShowAdministrator("unitAdministrator");
            }}
            selectImg={selectImg}
            toPerfect={ToPerfect}
            doShowQRCode={doShowQRCode}
            doSwitchDefaultAvatar={doSwitchDefaultAvatar}
            authData={authData}
            teamUserInfo={teamUserInfo}
          />
        )}
        {/* 恢复默认头像 */}
        {visibleDefaultAvatar && (
          <RestoreDefaultAvata visible={visibleDefaultAvatar} onCancel={doSwitchDefaultAvatar} />
        )}
        {/* 延期 */}
        {visibleAccountDelay && visible && (
          <AccountDelay
            visible={visibleAccountDelay}
            onCancel={doSwitchAccountDelay}
            title="账号有效期"
            validDate={userInfo?.validDate}
          />
        )}
      </>
    );
  }, [
    userMedalWall,
    currentEmployee,
    headImg,
    username,
    userInfo,
    userInfolistV2,
    workStatus,
    t,
    userStatusClick,
    itemListV2,
    visibleQRCode,
    doSwitchQRCode,
    visiblePersonal,
    doPersonalInfo,
    selectImg,
    ToPerfect,
    doShowQRCode,
    doSwitchDefaultAvatar,
    authData,
    teamUserInfo,
    visibleDefaultAvatar,
    visibleAccountDelay,
    visible,
    doSwitchAccountDelay,
    doShowAdministrator
  ]);

  // const menu = (
  //   <Menu>
  //     <Menu.Item>
  //       <span onClick={selectImg}>上传文件</span>
  //     </Menu.Item>
  //     <Menu.Divider />
  //     <Menu.Item disabled={headImg ? false : true}>
  //       <span
  //         onClick={() => {
  //           if (headImg) {
  //             doSwitchDefaultAvatar();
  //           }
  //         }}
  //       >
  //         恢复默认头像
  //       </span>
  //     </Menu.Item>
  //   </Menu>
  // );
  if (
    !(appRuntimeEnv?.registryConfig?.auth && appRuntimeEnv?.selectedTeamId) ||
    (config && !config.layout_user_center) ||
    !authData
  ) {
    return <div className="userCenter no-draggable" />;
  }
  //   // 不展示用户中心所有功能
  //   if (config && !config.layout_user_center) {
  //     return null;
  //   }

  //   if (!authData) {
  //     return null;
  //   }

  let userInfolist: any[] = [];
  if (userInfo) {
    const { fields = [] } = userInfo;
    const deptInfo = userInfo?.partTimeTitleDeptInfo?.[0];

    // const dept = fields.find((item) => item.key === 'e_dept_full_name');
    // const unitName = fields.find((item) => item.key === 'unitName');
    // unitName?.val && userInfolist.push({ key: '单位', value: unitName.val });
    if (deptInfo?.unitName) userInfolist.push({ key: "单位", value: deptInfo?.unitName });
    if (deptInfo?.deptName) userInfolist.push({ key: "部门", value: deptInfo?.deptName });
    if (deptInfo?.titleName) userInfolist.push({ key: "职务", value: deptInfo?.titleName });
    if (deptInfo?.titleDutyName) userInfolist.push({ key: "职责", value: deptInfo?.titleDutyName });
    // if (dept?.val) {
    //     const depts = dept.val.split('-') || [];
    //     userInfolist.push({ key: '部门', value: depts[depts.length - 1] });
    // }
    // const position = fields.find((item) => item.key === 'e_position');
    // position?.val && userInfolist.push({ key: '职务', value: position.val });

    const mobile = fields.find((item) => item.key === "mobile");
    // mobile?.val && userInfolist.push({ key: "手机", value: mobile.val });

    const email = fields.find((item) => item.key === "email");
    email?.val && userInfolist.push({ key: "邮箱", value: email.val });

    const cardNumber = fields.find((item) => item.key === "cardNumber");
    // crossAppSwitch("addressBook") && userInfolist.push({ key: "北京通号", value: cardNumber?.val });
    // (userInfo?.partTimeTitleDeptInfo?.[0].titleDutyName ||
    //     userInfo?.mainTitleDeptInfo?.titleDutyName) &&
    //     userInfolist.push({
    //         key: '职责',
    //         value:
    //             userInfo?.partTimeTitleDeptInfo?.[0].titleDutyName ||
    //             userInfo?.mainTitleDeptInfo?.titleDutyName,
    //     });
  }

  const body = (
    <div>
      <div className="avatar-wraps">
        <div className="avatar-wrap">
          <Avatar
            styleObj={{
              width: 52,
              height: 52,
              borderRadius: 6,
              overflow: "hidden",
              fontSize: 20,
              cursor: "pointer"
            }}
            tag={currentEmployee?.accountType === 1 ? "公共账号" : ""}
            src={headImg ? changeEgovUrl(getHeadImgThumbUrl(headImg, 150, 150)) : ""}
            name={username}
            onClick={() => {
              doPersonalInfo();
              setVisible(false);
            }}
            // onClick={() => {
            //   analysisLog("xtbg_pc_personal_infor_1687846378111", "1");
            //   if (authData) {
            //     const { ddAppId, userId } = authData;
            //     if (teamUserInfo) {
            //       const { teamId } = teamUserInfo;
            //       onOpenUserCard({ appId: ddAppId, userId, teamId });
            //       setVisible(false);
            //     }
            //   }
            // }}
            onLoadError={() => {
              loadError.current = true;
            }}
          />

          {/* <span className="change-user-avatar" onClick={selectImg}>
            <IconFont
              style={{
                fontSize: 17,
                color: "white",
                backgroundColor: "#c2c2c3",
                padding: "2px 5px",
                borderTopLeftRadius: 5,
                borderBottomRightRadius: 5
              }}
              type="iconapp_btn_camera_4"
            />
          </span> */}

          {/* <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
              Click me <Icon type="down" />
            </a> */}
          {/* <Dropdown
            overlay={menu}
            trigger={["click"]}
            placement="bottomRight"
            getPopupContainer={(trigger) => {
              return trigger.parentNode as HTMLElement;
            }}
          >
            <span
              className="change-user-avatar"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <IconFont
                style={{
                  fontSize: 17,
                  color: "white",
                  backgroundColor: "#c2c2c3",
                  padding: "2px 5px",
                  borderTopLeftRadius: 5,
                  borderBottomRightRadius: 5
                }}
                type="iconapp_btn_camera_4"
              />
            </span>
          </Dropdown> */}
        </div>
        <div className="name-wrap">
          <div>
            <div className="nickname-box">
              <h4
                style={{
                  margin: "0px 5px 0px 0px",
                  color: `${colors.black2}`,
                  fontSize: 16,
                  lineHeight: "28px"
                }}
              >
                {username}
              </h4>
              {userInfo?.labelInfoList && tagsNode(userInfo?.labelInfoList)}
            </div>

            <IconFont
              type="iconbtn_tabbar_m"
              onClick={doShowQRCode}
              style={{
                opacity: 0.5,
                marginRight: "-14px",
                cursor: "pointer",
                padding: "7px 14px",
                display: "block"
              }}
              className="qr-code"
              clstag="pageclick|keycount|xtbg_pc_personal_infor_1687846378111|2"
            />
          </div>

          <p
            className="multiline-overflow-1 color-gray user-status"
            onClick={userStatusClick}
            style={{
              margin: 0,
              fontSize: 13,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              cursor: "pointer"
            }}
            clstag="pageclick|keycount|focus_home_01_1615797361152|9"
          >
            <IconFont type="iconapp_btn_edit" style={{ marginRight: "4px" }} />
            {/* {workStatus || "状态"} */}
            {workStatus || IconAddWorkStatus}
          </p>
        </div>
      </div>
      {/* <div className="user-info-entrance">
        <div
          onClick={() => {
            doPersonalInfo();
            setVisible(false);
          }}
        >
          <IconFont
            style={{
              color: "#1686FF",
              paddingRight: "5px"
            }}
            type="icona-ic_appc_personid_kuangjia"
          />
          个人信息
        </div>
        <div
          onClick={() => {
            analysisLog("xtbg_pc_personal_infor_1687846378111", "1");
            if (authData) {
              const { ddAppId, userId } = authData;
              if (teamUserInfo) {
                const { teamId } = teamUserInfo;
                onOpenUserCard({ appId: ddAppId, userId, teamId });
                setVisible(false);
              }
            }
          }}
        >
          <IconFont
            style={{
              color: "#1686FF",
              paddingRight: "5px"
            }}
            type="icona-ic_appc_mycard_kuangjia"
          />
          我的名片
        </div>
        <div
          onClick={doShowQRCode}
          clstag="pageclick|keycount|xtbg_pc_personal_infor_1687846378111|2"
        >
          <IconFont
            style={{
              color: "#1686FF",
              paddingRight: "5px"
            }}
            type="iconbtn_tabbar_m"
          />
          二维码
        </div>
      </div> */}
      {/* {userInfo?.validDate && (
        <div className="account-delay">
          账号有效期至：{dayjs(userInfo?.validDate).format("YYYY年M月D日")}
          {userInfo?.canApplyDelay === 1 && (
            <span
              clstag="pageclick|keycount|xtbg_add_home_1637657110163|55"
              onClick={doShowAccountDelay}
            >
              申请延期
            </span>
          )}
          {visibleAccountDelay && visible && (
            <AccountDelay
              visible={visibleAccountDelay}
              onCancel={doSwitchAccountDelay}
              title="账号有效期"
              validDate={userInfo?.validDate}
            />
          )}
        </div>
      )} */}
      <div>
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px"
            }}
          >
            <Loading />
          </div>
        )}
        {userInfolist.map((item, index) => {
          return (
            <div
              key={index}
              className={`user-info-lists ${
                ["部门", "单位"].includes(item.key) ? "click-menu" : ""
              }`}
              onClick={() => userInfoCallback(item)}
            >
              <span>{item.key}</span>
              {item.key === "职责" ? (
                <Tooltip placement="top" title={item.value} arrowPointAtCenter>
                  <span className="titleDutyClassName">{item.value} </span>
                </Tooltip>
              ) : (
                <span>
                  {item.value || (
                    <span
                      onClick={debounce(() => {
                        ToPerfect();
                      }, 500)}
                      style={{
                        cursor: "pointer",
                        color: `${colors.primary2}`
                      }}
                    >
                      去完善
                    </span>
                  )}
                </span>
              )}
              {/* <span className={item.key === '职责' ? 'titleDutyClassName' : ''}>
                                {item.value || (
                                    <span
                                        onClick={debounce(() => {
                                            ToPerfect();
                                        }, 500)}
                                        style={{ cursor: 'pointer', color: '#4C7CFF' }}
                                    >
                                        去完善
                                    </span>
                                )}
                            </span> */}
              {["部门", "单位"].includes(item.key) && <span>{IconArrowRight}</span>}
            </div>
          );
        })}
        {userInfo?.validDate && (
          <div className="account-delay">
            账号有效期至：{dayjs(userInfo?.validDate).format("YYYY年M月D日")}
            {userInfo?.canApplyDelay === 1 && (
              <span
                clstag="pageclick|keycount|xtbg_add_home_1637657110163|55"
                onClick={doShowAccountDelay}
              >
                申请延期
              </span>
            )}
            {visibleAccountDelay && visible && (
              <AccountDelay
                visible={visibleAccountDelay}
                onCancel={doSwitchAccountDelay}
                title="账号有效期"
                validDate={userInfo?.validDate}
              />
            )}
          </div>
        )}
        {/* <div style={{ color: "#8f959e", padding: "9px 24px" }}>
          如有问题请联系
          {userInfo?.userType === "1" && (
            <>
              <span
                style={{ color: `${colors.primary2}`, cursor: "pointer" }}
                onClick={() => {
                  doShowAdministrator("Administrator");
                }}
                clstag="pageclick|keycount|xtbg_add_home_1637657110163|57"
              >
                管理者
              </span>
              或
            </>
          )}
          <span
            style={{ color: `${colors.primary2}`, cursor: "pointer" }}
            onClick={() => {
              doShowAdministrator("unitAdministrator");
            }}
            clstag="pageclick|keycount|xtbg_add_home_1637657110163|58"
          >
            单位管理员
          </span>
          {visibleAdministrator.visible && visible && (
            <AdministratorModal
              visible={visibleAdministrator.visible}
              onCancel={doSwitchAdministrator}
              type={visibleAdministrator.type}
            />
          )}
        </div> */}
      </div>
      {divider}
      {showJoinOrCreateTeam && (
        <Item
          text={joinMeT(getTranslationName(appRuntimeEnv, "joinOrCreate"))}
          icon={IconGroup}
          onClick={() => {
            if (onItemClick) {
              onItemClick(UserCenterItemType.JoinMe);
            }
            setVisible(false);
          }}
        />
      )}
      {!!crossAppSwitch("help") && (
        <Item
          text="常用网址"
          icon={IconWebAddres}
          onClick={() => {
            const url = changeEgovUrl(
              "https://jzb.beijing.gov.cn/guide/#/webAddress?timestamp=" + Date.now()
            );
            const pre_url =
              "https://jzb-pre.jdcloud.com/jingzhiban#/webAddress?timestamp=" + Date.now();
            window.open(appRuntimeEnv.key === "prod" ? url : pre_url, "_blank");
            // FocusSDK.emit("showNetTable");
          }}
        />
      )}
      {isFocusEnv() && !!crossAppSwitch("netWork") && (
        <Item
          text="网络检测"
          icon={<GlobalOutlined />}
          onClick={() => {
            FocusSDK.emit("showNetTable");
          }}
        />
      )}
      <Item
        text={t("userCenter.feedback")}
        icon={IconRdit}
        onClick={() => {
          if (onItemClick) {
            onItemClick(UserCenterItemType.Feedback);
          }
          setVisible(false);
        }}
        clstag="pageclick|keycount|focus_home_01_1615797361152|7"
      />
      <Item
        text="系统设置"
        rightChildrenFn={null}
        icon={IconSet}
        onClick={() => {
          // FocusSDK.checkUrlOnline({
          //     type: 'zoomNet',
          //     isPrivateNet: FocusSDK.isPrivateNet(),
          // });
          setVisible(false);
          history.push("/systemSetting");
        }}
        clstag="pageclick|keycount|focus_home_01_1615797361152|8"
      />
      {divider}
      <Item
        key="userCenter.logout"
        withArrow={false}
        text={t("userCenter.logout")}
        className="logout-btn"
        icon={IconExit}
        onClick={() => {
          if (onItemClick) {
            setWorkbenchDetail({
              currentSelectedWorkbench: {}
            });
            onItemClick(UserCenterItemType.Logout);
            setTimeout(() => {
              setVisible(false);
            }, 20);
          }
          // setVisible(false);
        }}
      />
      {/* 关于我们 */}
      <AboutModal
        service={service}
        visible={isAboutModalVisible}
        onCancel={() => setAboutModalVisible(!isAboutModalVisible)}
      />
      {/* 二维码 */}
      {visibleQRCode && (
        <PersonalQRCode
          userInfo={currentEmployee}
          visible={visibleQRCode}
          onCancel={doSwitchQRCode}
        />
      )}
      {/* 个人信息 */}
      {visiblePersonal && (
        <PersonalInfoModal
          visible={visiblePersonal}
          onCancel={doPersonalInfo}
          userInfo={userInfo}
          headImg={headImg}
          username={username}
          showAdminModal={() => {
            doShowAdministrator("Administrator");
          }}
          showUnitAdminModal={() => {
            doShowAdministrator("unitAdministrator");
          }}
          selectImg={selectImg}
          toPerfect={ToPerfect}
          doShowQRCode={doShowQRCode}
          doSwitchDefaultAvatar={doSwitchDefaultAvatar}
          authData={authData}
          teamUserInfo={teamUserInfo}
        />
      )}
      {/* 恢复默认头像 */}
      {visibleDefaultAvatar && (
        <RestoreDefaultAvata visible={visibleDefaultAvatar} onCancel={doSwitchDefaultAvatar} />
      )}
    </div>
  );

  const popperBody = (
    <div
      className="userCenterPopper v2"
      ref={setPopperElement as any}
      style={{
        ...popperStyles.popper,
        display: visible ? "block" : "none",
        position: "fixed"
      }}
      {...attributes.popper}
    >
      {userCenterBodyV2}
    </div>
  );

  const openUserCard = () => {
    if (!config || config?.layout_user_center_card) {
      if (!visible) {
        Bus.emit("onHideGlobalSearch");
        Bus.emit("handleBigScreenHideGlobalSearch");
      }
      setVisible(!visible);
    }
  };

  return (
    <div style={{ flexBasis: 55 }}>
      {visible && (
        <div
          onClick={() => {
            setVisible(false);
          }}
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 100
          }}
        />
      )}
      {(!config || config?.layout_user_center_head_img) && (
        <div className="userCenter no-draggable" style={{ zIndex: 100, position: "relative" }}>
          <a ref={setReferenceElement as any} className="userAvatar" onClick={openUserCard}>
            <Avatar
              styleObj={{
                width: 32,
                height: 32,
                overflow: "hidden",
                border: "none",
                borderRadius: 0
              }}
              tag={currentEmployee?.accountType === 1 ? "公共账号" : ""}
              src={changeEgovUrl(getHeadImgThumbUrl(headImg || "", 150, 150))}
              name={username}
            />
            {notify && <span className="userCenterNotify" />}
          </a>
        </div>
      )}
      {/* {superAdmin && popperBody} */}
      {popperBody}
      <Modal
        centered
        width="640px"
        style={{ height: 480, overflow: "hidden" }}
        bodyStyle={{ padding: "0 0 18px" }}
        title={sanding.title + "三定"}
        visible={sanding.visible}
        footer={null}
        onCancel={() => {
          setSanding({ ...sanding, visible: false });
          setTimeout(() => {
            setSanding({ visible: false, content: "", title: "" });
          }, 100);
        }}
      >
        <div className="sanding-wrap">
          <p>{sanding.content}</p>
        </div>
      </Modal>
    </div>
  );
}

export default connect(
  ({ chat, ebook, user }: { chat: ChatState; ebook: EbookState; user: UserState }) => {
    return {
      currentEmployee: chat?.currentEmployee ? chat?.currentEmployee : {},
      manageExternalModal: ebook.manageExternalModal,
      connectState: chat?.connectState.state,
      upgradeState: user?.upgradeState,
      commonConfig: user.commonConfig,
      userMedalWall: user.userMedalWall
    };
  },
  (dispatch: any) => ({
    clearJoyspaceData() {
      dispatch({ type: "joyspace/clearData", payload: {} });
    },
    getWebUserData(data: { teamUserInfo: UserModel }) {
      dispatch({ type: "user/getWebUserData", payload: { userData: data } });
    },
    clearChatData: () => {
      dispatch({ type: "chat/clearData" });
    },
    clearCalendarData: () => {
      dispatch({ type: "calendar/clearData" });
    },
    clearEbookData() {
      dispatch({ type: "ebook/clearEbookData" });
    },
    clearUserData() {
      dispatch({ type: "user/clearUserData" });
    },
    clearThirdData() {
      dispatch({ type: "thirdapp/clearThirdData" });
    },
    setIdentityInfoModal(payload: boolean) {
      dispatch({ type: "chat/setIdentityInfoModal", payload });
    },
    updateCurrentEmployee(payload: any) {
      dispatch({ type: "chat/updateCurrentEmployee", payload });
    },
    setOpenAdministratorListModal(payload: any) {
      dispatch({ type: "ebook/setOpenAdministratorListModal", payload });
    },
    setManageExternalModal(payload: any) {
      dispatch({ type: "ebook/setManageExternalModal", payload });
    },
    setWorkbenchDetail: (payload: any) => {
      dispatch({ type: "workbench/setWorkbenchDetail", payload });
    },
    setUserMedalWall: (payload: any) => {
      dispatch({ type: "user/setUserMedalWall", payload });
    }
  })
)(UserCenter);
